import {Load} from "./Load";

export class Form
{
    constructor(el)
    {
        this.form = el;
        this.form.classList.add('active');
        this.formId = parseInt(el.dataset.formId);
        this.submitted = false;
        this.form.addEventListener('submit', e =>
        {
            e.preventDefault();
            if(this.submitted === false)
            {
                this.submitted = true;
                this.process_submit();
            }
        });

        // toggle conditions based on checked state
        const checkboxes = this.form.querySelectorAll('.w__input--checkbox[data-f="form-toggle-condition"]');
        for(let i=0; i<checkboxes.length; i++)
        {
            Form.toggle_condition(checkboxes[i]);
        }
    }

    process_submit()
    {
        if(this.check_required())
        {
            this.form.querySelector('input[name="isPosted"]').value = '1';

            Load.post(
                document.location.pathname,
                {
                    f: 'form',
                    action: 'submit',
                    formId: this.formId,
                    fields: this.gather_data()}).then(r =>
            {
                this.form.closest('.w__article--text').innerHTML = r['html'];
            }).catch(() =>
            {
                this.submitted = false;
            });
        }
        else
        {
            this.submitted = false;
        }
    }

    gather_data()
    {
        const fields = this.form.querySelectorAll('input,select,textarea'),
              data = {};
        let el;

        for(let i=0; i<fields.length; i++)
        {
            el = fields[i];
            if(!el.closest('.mod--off'))
            {
                switch(el.type)
                {
                    case 'radio':
                    case 'checkbox':
                        if(el.checked)
                        {
                            data[el.name] = el.value;
                        }
                        break;

                    default:
                        data[el.name] = el.value.trim();
                        break;
                }
            }
        }

        return data;
    }

    check_required()
    {
        let ok = true;
        const fields = this.form.querySelectorAll('input[data-required="1"],input[data-alternative],select[data-required="1"],textarea[data-required="1"]');
        for(let i=0; i<fields.length; i++)
        {
            let error = false;

            if(fields[i].dataset.alternative)
            {
                const altEl = this.form.querySelector('input[name="' + fields[i].dataset.alternative + '"]');
                if(this.check_value(fields[i]) === false &&
                   altEl && this.check_value(altEl) === false)
                {
                    error = true;
                }
            }
            else if(!fields[i].closest('.mod--off') && this.check_value(fields[i]) === false)
            {
                error = true;
            }

            if(error === true)
            {
                const parentEl = fields[i].closest('.w__input--container');
                if(parentEl)
                {
                    parentEl.classList.add('w__input--error');
                    if(ok === true)
                    {
                        ok = false;
                        parentEl.scrollIntoView();
                    }
                }
            }
        }

        return ok;
    }

    check_value(el)
    {
        let ok;

        switch(el.type)
        {
            case 'radio':
                ok = false;
                const radios = el.closest('.w__input--radio-container')
                                 .querySelectorAll('.w__input--radio[name="' + el.name + '"]');
                for(let i=0; i<radios.length; i++)
                {
                    if(radios[i].checked)
                    {
                        ok = true;
                    }
                }
                break;

            case 'checkbox':
                ok = !!el.checked;
                break;

            case 'email':
                ok = Form.valid_email(el.value.trim());
                break;

            case 'number':
                ok = ((el.min && parseInt(el.value) >= parseInt(el.min)) ||
                    (!el.min && parseInt(el.value) > 0));
                break;

            default:
                ok = !!el.value.trim();
                break;
        }

        return ok;
    }

    static valid_email(email)
    {
        const reg = /^([A-Za-z\d_\-.])+@([A-Za-z\d_\-.])+\.([A-Za-z]{2,8})$/;
        return reg.test(email);
    };


    static toggle_condition(el)
    {
        const fields = el.closest('form')
                         .querySelectorAll('.w__input--container[data-conditional-field="' + el.name + '"]');

        if(el.checked)
        {
            for(let i=0; i<fields.length; i++)
            {
                fields[i].classList.remove('mod--off');
                if(fields[i].classList.contains('w__required'))
                {
                    const myInput = fields[i].querySelector('.w__input');
                    if(myInput)
                    {
                        myInput.setAttribute('required', '');
                        myInput.dataset.required = '1';
                    }
                }
            }
            if(el.dataset.alternative)
            {
                const altEl = el.closest('form')
                                .querySelector('.w__input--checkbox[name="' + el.dataset.alternative + '"]');
                if(altEl && altEl.checked)
                {
                    altEl.checked = false;
                    Form.toggle_condition(altEl);
                }
            }
        }
        else
        {
            for(let i=0; i<fields.length; i++)
            {
                fields[i].classList.add('mod--off');
                const myInput = fields[i].querySelector('.w__input');
                if(myInput)
                {
                    myInput.removeAttribute('required');
                    myInput.dataset.required = '';
                }
            }
        }
    }
}